import React from 'react';
import './AchievementsList.css';

export const AchievementsList = ({ achievements, unlockedAchievements, getProgress }) => {
  const achievementArray = Object.values(achievements);

  const isUnlocked = (achievementId) => {
    return unlockedAchievements.includes(achievementId);
  };

  return (
    <div className="achievements-list">
      {achievementArray.map(achievement => {
        const unlocked = isUnlocked(achievement.id);
        const progress = getProgress(achievement.id);

        return (
          <div
            key={achievement.id}
            className={`achievement-item ${unlocked ? 'unlocked' : 'locked'}`}
          >
            <div className="achievement-icon">
              {unlocked ? achievement.icon : '🔒'}
            </div>
            <div className="achievement-details">
              <div className="achievement-name">
                {unlocked ? achievement.name : '???'}
              </div>
              <div className="achievement-description">
                {unlocked ? achievement.description : 'Hidden achievement'}
              </div>
              {!unlocked && progress > 0 && (
                <div className="achievement-progress">
                  <div className="achievement-progress-bar">
                    <div
                      className="achievement-progress-fill"
                      style={{ width: `${progress}%` }}
                    />
                  </div>
                  <div className="achievement-progress-text">
                    {progress.toFixed(0)}%
                  </div>
                </div>
              )}
            </div>
            {unlocked && (
              <div className="achievement-checkmark">✓</div>
            )}
          </div>
        );
      })}
    </div>
  );
};
